import Icon from 'components/UIKit/Icon/Icon';
import style from './sideNavStyle';

export type SideNavGroupType = {
  children: any,
  style: ?any,
  name: ?string,
  active: ?boolean,
  customDataTestID?: string,
  handleClick: ?() => {}
}

export default function SideNavGroup({
  children,
  name, active,
  customDataTestID,
  handleClick,

}: SideNavGroupType) {
  return (
    <div data-testid={customDataTestID} style={{ borderBottom: '1px solid #e5e5e5' }}>
      {name && (
        <div
          style={style.navGroupHeader}
          onClick={() => handleClick(name)}
          >
          <span>{ name }</span>
          <Icon
            style={{
              marginLeft: 'auto',
              transform: `rotate(${active ? 180 : 0}deg)`,
              transition: 'transform 0.3s ease',
            }}
            >
          keyboard_arrow_down
          </Icon>
        </div>
      )}
      <div
        style={{
          maxHeight: active ? 0 : '70rem',
          transition: 'max-height 0.3s ease',
          overflow: 'hidden',
        }}
        >
        { children }
      </div>
    </div>
  );
}
